const config = {
  shortLinkDomain: 'http://jnews.co/',
  cloudFrontDomain: 'https://cdn.jewishnews.net.au/',

  // cloudFrontDomain: 'https://d2xl5k6j09j1pg.cloudfront.net/',
  version: '2.1.0',
};
export default config;
